import config from '@/config.js'

const UnleashFlagTurnOnTimeMapProd = {
  'AHA-30192-presenter-change-slide': new Date(Date.UTC(2024, 11, 11, 10, 0, 0)), // 17h UTC+7 11/12/2024
}

const UnleashFlagTurnOnTimeMapDev = {
  'AHA-30192-presenter-change-slide': new Date(Date.UTC(2024, 11, 7, 10, 0, 0)), // 17h UTC+7 7/12/2024
}

const UnleashFlagTurnOnTimeMap = config.env === 'production' ? UnleashFlagTurnOnTimeMapProd : UnleashFlagTurnOnTimeMapDev

export default UnleashFlagTurnOnTimeMap
